"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ElementalDischargeAbilityHandler = exports.ElementalDischargeActorAbilityFactory = exports.ElementalDischargeAbilityArgs = void 0;
const AbilityType_1 = require("../../core/abilities/AbilityType");
const ActorAbilityState_1 = require("../../core/actors/ActorAbilityState");
const Registries_1 = require("../../core/state/Registries");
const Target_1 = require("../../core/Target");
const core_1 = require("../../core/effects/core");
const Duration_1 = require("../../core/Duration");
const enums_1 = require("../../core/enums");
const AbilityDamage_1 = require("../../core/AbilityDamage");
class ElementalDischargeAbilityArgs {
    constructor(target) {
        this.target = target;
        this.__type = AbilityType_1.AbilityType.ElementalDischarge;
        this.__typeName = "ElementalDischarge";
    }
}
exports.ElementalDischargeAbilityArgs = ElementalDischargeAbilityArgs;
let ElementalDischargeActorAbilityFactory = class ElementalDischargeActorAbilityFactory {
    mk() {
        return new ActorAbilityState_1.ActorAbilityState("ElementalDischarge", "AllEnemies", 0);
    }
};
ElementalDischargeActorAbilityFactory = __decorate([
    Registries_1.ActorAbilities.register("ElementalDischarge")
], ElementalDischargeActorAbilityFactory);
exports.ElementalDischargeActorAbilityFactory = ElementalDischargeActorAbilityFactory;
let ElementalDischargeAbilityHandler = class ElementalDischargeAbilityHandler {
    init(sequence, container, actorId) { }
    activate(sequence, container, ability) {
        const targets = container.selectLivingTargets(ability.invokerId, Target_1.Target.AllEnemies);
        container.applyProjectileAttacksWithDamage({
            sequence,
            abilityKey: ability.args.__typeName,
            attackType: "magic",
            attackerId: ability.invokerId,
            projectiles: targets.map((targetId) => {
                return {
                    creatorId: ability.invokerId,
                    targetId,
                    jitter: 100,
                    type: "ElectricExplodingWhiteOrb",
                    path: "arc",
                    damages: Array.of("Fire", "Frost", "Nature", "Sonic")
                        .map((damageType) => AbilityDamage_1.AbilityDamage.Focus(damageType, 50))
                };
            }),
            onHit(sequence, _attack, _damages, { targetId }) {
                const effect = new core_1.LinkedEffectsEffectArgs([
                    ...[
                        enums_1.AttributeType.FireDamageImmunity,
                        enums_1.AttributeType.FrostDamageImmunity,
                        enums_1.AttributeType.NatureDamageImmunity,
                        enums_1.AttributeType.SonicDamageImmunity
                    ]
                        .map(attr => new core_1.MaxAttributeDecreaseEffectArgs(attr, Math.max(0, Math.min(0, container.getAttributeScore(targetId, attr) - 5))))
                        .filter(attr => attr.amount > 0)
                ], true);
                if (effect.effects.length > 0) {
                    container.applyDebuff({
                        sequence,
                        attackerId: ability.invokerId,
                        targetId: targetId,
                        duration: Duration_1.Duration.Permanent,
                        effect
                    });
                }
            }
        });
    }
};
ElementalDischargeAbilityHandler = __decorate([
    Registries_1.Abilities.register(AbilityType_1.AbilityType.ElementalDischarge)
], ElementalDischargeAbilityHandler);
exports.ElementalDischargeAbilityHandler = ElementalDischargeAbilityHandler;
